import React from 'react'

const statusClasses = {
  "All": "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  "Qualified": "bg-[#15B392]",
  "Booked": "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]"
};

const PatientJourneyIn = ({ trialInfo }) => {
  return (
    <><h2 className='mb-2'>{trialInfo?.trialName}</h2>

      {trialInfo?.status && (<span className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble ${statusClasses[trialInfo?.status] || "bg-gray-200"}`}>{trialInfo?.status}</span>)}
    </>
  )
}

export default PatientJourneyIn